/* eslint-disable */

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({ 
    state: {
        filesAdd: [],
        token: 0,
        anotherVar: '',
        locationMain: true,
        locationAdd: false,
        locationsArrow: null,
        locationsEdite: null,
        statusesArrow: null,
        AddHeader: 'ДОБАВИТЬ ОБЪЕКТ',
        objectVisibleMain: true,
        objectVisibleAdd: false,
        objectsArrow: null,
        objectEdite: null,
        objectInfo: null,
        objectAdd: false,
        bookingArrow: [],
        staffVisibleMain: true,
        staffVisibleAdd: false,
        staffArrow: null,
        staffEdite: null,
        staffAdd: false,
        profile: {
            id: 11,
            name: null,
            partner: {
                id: 3,
                manager: {
                    email: "",
                    id: '',
                    name: "",
                    phone: "",
                    picture: "",
                    position: "",
                    schedule: ""
                },
                name: '',
                worker: {
                    id: 9,
                    name: '',
                    email: 'mvg1984@inbox.ru',
                    role: ''
                },
                workers_count: 4,
                locations_count: 1,
                rooms_count: 1,
                partners_list: [
                    {
                        id: 3,
                        name: ''
                    }
                ],
                worker: {
                    permissions: {
                        bookings: false,
                        reports: false,
                        rooms: false,
                        workers: false
                    }
                }
            },
            locations_count: 0,
            rooms_count: 0,
            workers_count: 0
        }
    },
    mutations: {
        filesAdd(state, value) {
            state.filesAdd = value;
        },
        setToken(state, value) {
            state.token = value;
        },
        sendToken() {
            return state.token
        },
        setAnotherVar(state, value) {
            state.anotherVar = value
        },
        logout(state){
            state.token = ''
            state.anotherVar = ''
        },
        locationMain(state){
            state.locationMain = true
            state.locationAdd = false
        },
        locationAdd(state){
            state.locationMain = false
            state.locationAdd = true
        },
        locationsArrow(state, data) {
            state.locationsArrow = data
        },
        locationsEdite(state, data) {
            state.locationsEdite = data
        },
        statusesArrow(state, data) {
            state.statusesArrow = data
        },
        AddHeader(state, data){
            state.AddHeader = data
        },
        objectVisibleMain(state){
            state.objectVisibleMain = true
            state.objectVisibleAdd = false
        },
        objectVisibleAdd(state){
            state.objectVisibleMain = false
            state.objectVisibleAdd = true
        },
        objectsArrow(state, data){
            state.objectsArrow = data
        },
        objectInfo(state, data){
            state.objectInfo = data
        },
        objectEdite(state, data){
            state.objectEdite = data
        },
        objectAdd(state, data){
            state.objectAdd = data
        },
        bookingArrow(state, data){
            state.bookingArrow = data
        },
        staffVisibleMain(state){
            state.staffVisibleMain = true
            state.staffVisibleAdd = false
        },
        staffVisibleAdd(state){
            state.staffVisibleMain = false
            state.staffVisibleAdd = true
        },
        staffArrow(state, data){
            state.staffArrow = data
        },
        staffEdite(state, data){
            state.staffEdite = data
        },
        staffAdd(state, data){
            state.staffAdd = data
        },
        profileAdd(state, data){
            state.profile = data
            localStorage.bookings = data.partner.worker.permissions.bookings
            localStorage.objects = data.partner.worker.permissions.rooms
            localStorage.staff = data.partner.worker.permissions.workers
        }
    },
    getters: {
        filesAdd: state => state.filesAdd,
        token: state => state.token,
        anotherVar: state => state.anotherVar,
        locationMain: state => state.locationMain,
        locationAdd: state => state.locationAdd,
        locationsArrow: state => state.locationsArrow,
        locationsEdite: state => state.locationAdd,
        statusesArrow: state => state.statusesArrow,
        objectVisibleMain: state => state.objectVisibleMain,
        AddHeader: state => state.AddHeader,
        objectVisibleAdd: state => state.objectVisibleAdd,
        objectsArrow: state => state.objectsArrow,
        objectInfo: state => state.objectInfo,
        objectEdite: state => state.objectEdite,
        objectAdd: state => state.objectAdd,
        bookingArrow: state => state.bookingArrow,
        staffVisibleMain: state => state.staffVisibleMain,
        staffVisibleAdd: state => state.staffVisibleAdd,
        staffArrow: state => state.staffArrow,
        staffEdite: state => state.staffEdite,
        staffAdd: state => state.staffAdd,
        profileAdd: state => state.profile
    }
})


// WEBPACK FOOTER //
// ./src/store/store.js